const PAGINATION = {
    FIRST_PAGE: 1
};

let PaginatedListComponent = {
    listCardComponent: {},
    paginationControls: {},
    state: {
        querySet: '', // data displayed in paginated list
        page: 1, //Current page
        rows: 10, // max number of items displayed 
        total: 10, // total number of items
        window: 5, // Items in pagination component
        buttonTooltips: {
            firstPage: 'First Page',
            lastPage: 'Last Page',
            nextPage: 'Next Page',
            page: 'Page ',
            prevPage: 'Previous Page'
        }
    },
    queryString: '',
    showPage: {},
    init: function( paginatedListComponent, paginationControls, showPage) {
        this.listCardComponent = paginatedListComponent;
        this.paginationControls = paginationControls;
        this.showPage = showPage;

        // get the Number of Items per page
        let itemsPerPageField = document.querySelector('.page-number');
        if (itemsPerPageField) {
            this.setNumberOfItemsPerPage( itemsPerPageField.value );
            this.paginationControls.addEventListener('click', (e) => {
                let newPage = e.target.value;
                this.showPage(newPage, false).then((data) => {
                    history.pushState(this.state, '', this.queryString);
                });
            });
        }

        window.addEventListener("popstate", (event) => {
            this.state = event.state;
            this.showPage(this.state.page, true);
        });

        // allow page to scroll to top when restoring page state
        if (history.scrollRestoration) {
            history.scrollRestoration = "manual";
        }

    },
    clearControls: function() {
        this.paginationControls.innerHTML = '';
    },
    setPage: function(page) {
        this.state.page = page;
    },
    getPage: function() {
        return this.state.page;
    },
    setNumberOfItemsPerPage: function(numberOfItemsPerPage) {
        this.state.rows = numberOfItemsPerPage;
    },
    getNumberOfItemsPerPage: function() {
        return this.state.rows;
    },
    setTotalNumberOfItems: function(totalNoOfItems) {
        this.state.total = totalNoOfItems;
    },
    getTotalNumberOfItems: function() {
        return this.state.total;
    },
    setQuerySet: function(querySet) {
        this.state.querySet = querySet;
    },
    getQuerySet: function() {
        return this.state.querySet;
    },
    setButtonTooltips: function(buttonTooltips) {
        this.state.buttonTooltips = buttonTooltips;
    },
    getButtonTooltips: function() {
        return this.state.buttonTooltips;
    },
    getNumberOfPages: function() {
        return Math.ceil(this.state.total / this.state.rows);
    },
    setQueryString: function(queryString) {
        this.queryString = queryString;
    },
    getURL: function() {
        return `${window.location.origin}${window.location.pathname}${this.queryString}`;
    },
    adjustListCardComponentHeight: function() {
        this.listCardComponent.style.minHeight = `${Math.min(this.listCardComponent.scrollHeight, window.innerHeight)}px`;
        navUtils.scrollToTop();
    },
    pageButtons: function () {
        let pages = this.getNumberOfPages();
    
        let maxLeft = this.state.page - Math.floor(this.state.window / 2);
        let maxRight = this.state.page + Math.floor(this.state.window / 2);
    
        if (maxLeft < 1) {
            maxLeft = 1;
            maxRight = this.state.window;
        }
    
        if (maxRight > pages) {
            maxLeft = pages - (this.state.window - 1);
    
            if (maxLeft < 1) {
                maxLeft = 1;
            }
            maxRight = pages;
        }
    
        let pageActive;
        let componentHTML = '';
        for (let page = maxLeft; page <= maxRight; page++) {
            if (this.state.page === page) {
                pageActive = page;
                componentHTML = `${componentHTML}
                <li>
                    <button type="button" class="page active" value=${page}>
                        <span class="visually-hidden">${this.state.buttonTooltips.page}</span> ${page}
                    </button>
                </li>`;
            } else {
                componentHTML = `${componentHTML}
                <li>
                    <button type="button" class="page" value=${page}>
                        <span class="visually-hidden">${this.state.buttonTooltips.page}</span> ${page}
                    </button>
                </li>`;
            }
        }
    
        if (this.state.page != 1) {
            componentHTML =
                `<li class="page-first">
                    <button type="button" class="page" value='1'>
                        <span class="icon-double-chevron-left"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.firstPage}</span>
                    </button>
                </li>
                <li class="page-prev">
                    <button type="button" class="page" value='${pageActive - 1}'>
                        <span class="icon-single-chevron-left"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.prevPage}</span>
                    </button>
                </li> 
                ${componentHTML}`;
        } else {
            componentHTML =
                `<li class="disabled page-first">
                    <button type="button" class="page" tabindex="-1" value='1'>
                        <span class="icon-double-chevron-left"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.firstPage}</span>
                    </button>
                </li>
                <li class="disabled page-prev">
                    <button type="button" class="page" tabindex="-1" value='${pageActive - 1}'>
                        <span class="icon-single-chevron-left"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.prevPage}</span>
                    </button>
                </li>
                ${componentHTML}`;
        }
    
        if (this.state.page != pages) {
            componentHTML = `${componentHTML}
                <li class="page-next">
                    <button type="button" class="page" value='${pageActive + 1}'>
                        <span class="icon-single-chevron"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.nextPage}</span>
                    </button>
                </li>
                <li class="page-last">
                    <button type="button" class="page" value='${pages}'>
                        <span class="icon-double-chevron"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.lastPage}</span>
                    </button>
                </li>`;
        } else {
            componentHTML = `${componentHTML}
                <li class="disabled page-next">
                    <button type="button" class="page" tabindex="-1" value='${pageActive + 1}'>
                        <span class="icon-single-chevron"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.nextPage}</span>
                    </button>
                </li>
                <li class="disabled page-last">
                    <button type="button" class="page" tabindex="-1" value='${pages}'>
                        <span class="icon-double-chevron"></span>
                        <span class="visually-hidden">${this.state.buttonTooltips.lastPage}</span>
                    </button>
                </li>`;
        }

        this.paginationControls.innerHTML = componentHTML;
    }
};